var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2D9CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2804 3.15337C11.5009 3.15337 11.6786 3.22087 11.8131 3.35531C11.9475 3.48975 12.0144 3.66694 12.0144 3.888V10.4546C12.0144 11.2028 11.8372 11.8851 11.4817 12.4993C11.1429 13.0973 10.6509 13.5944 10.0564 13.9393C9.46124 14.2847 8.79412 14.4574 8.05443 14.4574C7.31531 14.4574 6.63862 14.2847 6.02381 13.9393C5.42926 13.5944 4.93729 13.0973 4.59843 12.4993C4.25306 11.8851 4.08037 11.2033 4.08037 10.4546C4.08037 9.70594 4.23843 9.02869 4.55568 8.424C4.88193 7.80975 5.32349 7.32937 5.88037 6.984C6.44681 6.63862 7.07568 6.46537 7.76643 6.46537C8.29832 6.46147 8.82428 6.57724 9.30537 6.80411C9.78647 7.03097 10.2104 7.36313 10.5457 7.776V3.888C10.5457 3.66694 10.6132 3.48975 10.7477 3.35531C10.8917 3.22038 11.0831 3.1478 11.2804 3.15337ZM8.05443 13.1614C8.53481 13.1614 8.96681 13.0466 9.35043 12.816C9.74093 12.5795 10.0597 12.2412 10.2724 11.8373C10.4929 11.4238 10.6037 10.9631 10.6037 10.4546C10.6037 9.94613 10.4929 9.48937 10.2718 9.08662C10.0616 8.68461 9.74224 8.35005 9.35043 8.12138C8.96681 7.88175 8.53481 7.76138 8.05443 7.76138C7.57462 7.76138 7.13756 7.88175 6.74381 8.12138C6.35636 8.35552 6.03832 8.68871 5.82243 9.08662C5.60193 9.48937 5.49168 9.94556 5.49168 10.4546C5.49168 10.9637 5.60193 11.4238 5.82243 11.8367C6.0408 12.2367 6.35825 12.5739 6.74437 12.816C7.13812 13.0466 7.57406 13.1614 8.05443 13.1614Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDat);
export default __webpack_public_path__ + "static/media/dat.0ef18a9fb171a0a2bcfcabb841c72319.svg";
export { ForwardRef as ReactComponent };